import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType } from 'firebase/index'
import { StoreTimesale } from 'types/storeTimesale'
import { fetchStoreTimesaleAction } from 'reducks/storeTimesale/actions'

const fetchStoreTimesale = (storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    return storeRef
      .collection('store_timesales')
      .limit(1)
      .get()
      .then((snapshots) => {
        const snapshot = snapshots.docs[0]
        if (!snapshot.exists) return
        const data = snapshot.data() as StoreTimesale
        data.ref = snapshot.ref
        dispatch(fetchStoreTimesaleAction(data))
      })
      .catch((error: unknown) => {
        console.error(error)
      })
  }
}

export default fetchStoreTimesale
